export enum AdType {
  adXStandard = 'adXStandard',
  prebidStandard = 'prebidStandard',
  prebidNative = 'prebidNative',
  adXNative = 'adXNative'
}
